import React from 'react'
import { connect } from 'react-redux'
import { Grid, withStyles, Typography, Paper, Hidden } from '@material-ui/core'
import SelectedActionButtons from './SelectedActionButtons'
// import SmartTaskField from './SmartTaskField'
import SplitForm from './SplitForm'
import Snackbar from './Snackbar'
import Name from './Name'
import styles from './styles'
import Prompt from './Prompt'
import language from 'utils/vast-languagepack'
import Automation from './Automation'
import ManagePhonesModal from 'components/ManagePhonesModal'
import Stepper from './Stepper'
import Wizard from 'components/TemplateForm/Wizard'
import Analyze from './Analyze'

const Form = ({
  classes,
  splitFormDisplayed,
  modal,
  stepper,
  selectedActionPrediction,
  disabled,
  delayCallToAction,
  scheduleCallToAction,
}) => {
  const step0 = (
    <Paper
      className={modal ? classes.initialFormModal : classes.initialForm}
      elevation={modal ? 0 : 2}
    >
      <Grid className={classes.grid} container spacing={16}>
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            {language.task.add.generalInfo}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Name />
        </Grid>
        {/* <Grid item xs={12}>
					<Typography variant="h5" gutterBottom>
						{language.task.add.taskDescription}
					</Typography>
				</Grid>
				<SmartTaskField /> */}
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            {language.task.add.taskType}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Hidden smDown>
            <SelectedActionButtons />
          </Hidden>
          <Hidden mdUp>
            <SelectedActionButtons select />
          </Hidden>
        </Grid>
      </Grid>
    </Paper>
  )
  const step1 = (
    <Paper
      className={modal ? classes.initialFormModal : classes.initialForm}
      elevation={modal ? 0 : 2}
    >
      <Grid
        // style={{ width: '100%' }}
        className={classes.grid}
        container
        spacing={16}
      >
        {!disabled && (
          <Grid item xs={12}>
            <Typography variant="h5" gutterBottom>
              {language.task.add.taskAutomation}
            </Typography>
          </Grid>
        )}
        <Automation
          delayCallToAction={delayCallToAction}
          scheduleCallToAction={scheduleCallToAction}
        />
      </Grid>
    </Paper>
  )
  const steps =
    selectedActionPrediction === 'email' || selectedActionPrediction === 'sms'
      ? [
          step0,
          step1,
          <Wizard modal={modal} taskForm />,
          <SplitForm modal={modal} />,
          <Analyze />,
        ]
      : [step0, step1, <SplitForm modal={modal} />, <Analyze />]
  return (
    <main
      // style={{ height: '100%' }}
      className={modal ? classes.mainModal : classes.main}
    >
      {steps[stepper]}
      <Stepper modal={modal} />
      <Snackbar />
      <ManagePhonesModal />
      <Prompt />
    </main>
  )
}
export default connect(state => {
  const taskID = state.tasks.addOrEdit.taskID
  const task = state.tasks.tasksByID[taskID]
  const stats = task?.sms_stats || task?.email_stats
  const campaignStatus =
    state.tasks.addOrEdit.originalCampaignSelected?.campaign?.status
  const taskModalOpen = state.campaign.addOrEdit.taskModalOpen
  const disabled = Boolean(
    (taskModalOpen && taskID === 'new') ||
      stats ||
      campaignStatus === 'L' ||
      campaignStatus === 'C',
  )
  const automationTypeSelected = state.tasks.addOrEdit.automationTypeSelected
  const delayCallToAction = Boolean(
    taskModalOpen && taskID === 'new' && automationTypeSelected === 'stage',
  )
  const scheduleCallToAction = Boolean(
    taskModalOpen && taskID === 'new' && automationTypeSelected === 'calendar',
  )
  return {
    disabled,
    splitFormDisplayed: state.tasks.addOrEdit.splitFormDisplayed,
    stepper: state.view.stepper.task,
    selectedActionPrediction:
      state.tasks.addOrEdit.fields.selectedActionPrediction.value,
    delayCallToAction,
    scheduleCallToAction,
  }
}, null)(withStyles(styles)(Form))
